$(function () {
    var slider = $('.testimonials-slider');
    var standAlone = $('.testimonial');

    var breakpoints = {};

    breakpoints.sm = 768;
    breakpoints.md = 992;
    breakpoints.lg = 1200;

    var sizeOfSlide = 370; // Size of a slide.


// For testimonial slider
    var maxTestimonialSlideToShow = Math.round(slider.width() / sizeOfSlide);

    var maxItemsToSlide = 1;

// Setting up how many to slider for testimonial.
    if (maxTestimonialSlideToShow <=0) {
        maxTestimonialSlideToShow =1;
    }

    if (maxTestimonialSlideToShow >1) {
        maxItemsToSlide = 2;
    }

    var sliderExpanders = (function () {
        var slideSelector = '.testimonials-slider__slide',
            slideTextSelector = '.testimonials-slider-slide__text',
            sliderTextExpanderSelector = '.testimonials-quote__expander';

        var hiddenClass = 'hidden';

        var $slides;

        function init($sel) {
            $slides = $sel.find(slideSelector);

            addFunctionality();
        }

        function addFunctionality() {
            if(!$slides){
                console.warn("testimonials addFunctionality called with no $slides, ignoring");
                return;
            }
            $slides.each(function () {
                var $this = $(this);
                var $slideTextSelector = $this.find(slideTextSelector);
                var slideText = $this.find(slideTextSelector)[0];
                var slideTextExpander = $this.find(sliderTextExpanderSelector);
                var sliderTextMinHeight = $this.find(slideTextSelector).css('height').slice(0, -2);

                if (slideText.scrollHeight <= sliderTextMinHeight) {
                    slideTextExpander.addClass(hiddenClass);
                } else {
                    _cropText($slideTextSelector);
                    _bindClick(slideTextExpander);
                }

            });

            function _cropText($selector) {
                $selector.data('text', $selector.html());

                $selector.ellipsis({
                    lines: 10
                });

                // debug:
                // console.log('_cropText');
            }

            function _bindClick(btn) {
                btn.click(function (e) {
                    var $this = $(this);
                    var relSliderText = $this.closest(slideSelector).find(slideTextSelector)

                    e.preventDefault();

                    // debug:
                    // console.log('data-text', relSliderText.data('text'));

                    _removeElipsis(relSliderText);

                    $this.closest(slideSelector).find(slideTextSelector).css({'height': 'auto', 'max-height': 'none'});

                    $this.addClass(hiddenClass);
                });

            }

        }

        function _removeElipsis(elm) {
            elm.html(elm.data('text'));
        }

        function resetFunctionality() {
            if(!$slides){
                console.warn("testimonials resetFunctionality called with no $slides, ignoring");
                return;
            }
            $slides.each(function () {
                var $this = $(this);

                var slideText = $this.find(slideTextSelector);
                var slideTextExpander = $this.find(sliderTextExpanderSelector);

                slideText.removeAttr('style');
                _removeElipsis(slideText);

                if (slideTextExpander.hasClass(hiddenClass)) {
                    slideTextExpander.removeClass(hiddenClass);
                }
            });
        }

        return {
            init: init,
            addFunctionality: addFunctionality,
            resetFunctionality: resetFunctionality
        };
    }());

    if ($(window).width() < breakpoints.sm) {
        window.addEventListener('orientationchange', function () {
            sliderExpanders.resetFunctionality();
            setTimeout(function () {
                sliderExpanders.addFunctionality();
            }, 500);
        });
    }

    standAlone.each(function () {
        var $this = $(this);

        sliderExpanders.init($this);

        $this.on('breakpoint', function () {
            sliderExpanders.resetFunctionality();
            sliderExpanders.addFunctionality();
        });
    });

    slider.each(function () {
        var $this = $(this);

        $this.on('init', function () {
            sliderExpanders.init($this);
        });

        $this.slick({
            accessibility: true,
            dots: true,
            infinite: false,
            slidesToShow: maxTestimonialSlideToShow,
            slidesToScroll: maxItemsToSlide,
            adaptiveHeight: true,
            prevArrow: $this.prev('.testimonials-wrapper').children('.testimonials-arrows').children('.testimonials-arrows__angle_left'),
            nextArrow: $this.prev('.testimonials-wrapper').children('.testimonials-arrows').children('.testimonials-arrows__angle_right'),
            responsive: [
                {
                    breakpoint: breakpoints.lg,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: breakpoints.md,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: breakpoints.sm,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    });


});
